/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';
import axios from 'axios';
import { getAccessToken } from '../Utilities/get-bedhub-token';
/**
 * BedhubFooterDataAction Input Action
 */
export class BedhubFooterInput implements Msdyn365.IActionInput {
  constructor() { }
  public getCacheKey = () => 'BedhubFooter';
  public getCacheObjectType = () => 'BedhubFooter';
  public dataCacheType = (): Msdyn365.CacheType => 'application';
}
const createInput = (args: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
  // Ensure Bedhub API is Enable
  if (args.config && !args.config.bedhubDataSource) {
    throw new Error('Cant call BEDHUB API, as its turn off');
  } else {
  return new BedhubFooterInput();
  }
};
async function getBedhubFooterData(input: BedhubFooterInput, ctx: Msdyn365.IActionContext): Promise<any> {
  const baseURL = ctx?.requestContext?.app?.config?.bedhubBaseUrl;
  let token = '';
  try {
    token = await getAccessToken(baseURL, ctx.requestContext);
  } catch (error) {
    console.error('error for getting bedhub footer authorization token [getAccessToken]', error);
  }
  const graphqlURL = new URL('graphql', baseURL).href;
  try {
    // Query to get the GRAPHQL Data
    const query = `
     {
      ui {
        disclosure {
          maximum
          more {
            ariaLabel
            label
          }
          sections {
            html
            truncate
          }
        }
        footer {
          accessibilityReader {
            ariaLabel
            image {
              url
            }
            label
            openInNewTab
            type
            url
          }
          categories {
            items {
              ariaLabel
              label
              openInNewTab
              type
              url
            }
            label
          }
          socials {
            ariaLabel
            image {
              url
            }
            label
            openInNewTab
            type
            url
          }
        }
      }
    }
        `;
    const response = await axios.post(
      graphqlURL,
      JSON.stringify({
        query: query
      }),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (response?.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    console.error('error for bedhub footer [getBedhubFooterData]', error);
    return {};
  }
}
export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<{}>>getBedhubFooterData,
  id: 'BedhubFooter',
  input: createInput
});

